export const getFirstName = (user) => {
  return user?.name?.split(' ')[1] || 'you'
}
